import { LineItemStyle } from "@faire/web-api--source/indigofair/data/LineItemStyle";

enum ClientLineItemStyle {
  MARKET = "MARKET",
  MARKET_NOT_LIVE = "MARKET_NOT_LIVE",
  IS_MARKED_DOWN = "IS_MARKED_DOWN",
  REFUND = "REFUND",
  HAS_DISCOUNT = "HAS_DISCOUNT",
  NO_DISCOUNT = "NO_DISCOUNT",
  INVOICE = "INVOICE",
  IS_DISCOUNT = "IS_DISCOUNT",
  IS_DISCOUNT_AND_BRAND_PROMO = "IS_DISCOUNT_AND_BRAND_PROMO",
}

export type ILineItemStyle =
  | keyof typeof LineItemStyle
  | keyof typeof ClientLineItemStyle
  | undefined;

export const ILineItemStyle = { ...LineItemStyle, ...ClientLineItemStyle };
